export default  {
    validatePhoneNumber(evt) {
        var theEvent = evt || window.event;

        // Handle paste
        if (theEvent.type === 'paste') {
            key = theEvent.clipboardData.getData('text/plain');
        } else {
        // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]|\r|\n/;
        if( !regex.test(key) ) {
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
    },
    validateNumber(evt) {
        var theEvent = evt || window.event;

        // Handle paste
        if (theEvent.type === 'paste') {
            key = theEvent.clipboardData.getData('text/plain');
        } else {
        // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]|\.|\r|\n/;
        if( !regex.test(key) ) {
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
    },
    validateString(evt) {
        var theEvent = evt || window.event;

        // Handle paste
        if (theEvent.type === 'paste') {
            key = theEvent.clipboardData.getData('text/plain');
        } else {
        // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /^[A-Za-z\s.]*$/;
        if( !regex.test(key) ) {
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
    },
    getCurrentISODate() {
        var moment = require('moment-timezone');
        var now = moment();
        var timeZone = 'Asia/Baghdad'; 
        var adjusted = now.tz(timeZone);
        adjusted.add(3, 'hours');
        
        return adjusted.toISOString();
    },
    // extractNumberFromString(str) {
    //     const regex = /[><=]*\d+(\.\d+)?/g;
    //     const matches = str.match(regex);
        
    //     if (matches && matches.length > 0) {
    //       const numberString = matches[0].replace(/[><=]/g, '');
    //       return parseFloat(numberString);
    //     }
        
    //     return str;
    // },
    extractNumberFromString(str) {
        if (!str) return null;

        // 1. Remove all non-digit and non-dot characters
        let cleaned = str.replace(/[^0-9.]/g, '');

        // 2. Count dots
        const dotCount = (cleaned.match(/\./g) || []).length;

        // Reject strings with more than one dot
        if (dotCount > 1) {
            return null;
        }

        // 3. Reject empty result (ex: string had no digits)
        if (cleaned.trim() === '') {
            return null;
        }

        // 4. Convert to numeric
        const num = parseFloat(cleaned);

        // If parseFloat fails
        if (isNaN(num)) return null;
        
        return num;
    },
    capitalizeFirstCharacter(string) {
        if (string && string.length > 0) {
          var firstCharacter = string.charAt(0);
          var capitalizedCharacter = firstCharacter.toUpperCase();
          var result = capitalizedCharacter + ((string || '').slice(1)).toLowerCase();
          return result;
        } else {
          return string;
        }
    },
    isEmpty(value) {
        return value === null || value === "" || value === undefined
    },
    isEnglishText(text) {
        if(!text) {
            return true
        }
        // Regular expression to match English letters and digits
        var englishLettersAndDigitsRegex = /^[a-zA-Z0-9\s!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]+$/;
        
        // Test if the text contains only English letters and digits
        return englishLettersAndDigitsRegex.test(text);
    },
    stripHtml(html) {
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    },
}